import { supabase } from "@/integrations/supabase/client";

type LooseResult = { data: unknown; error: { message: string } | null; count?: number | null };

type LooseQuery = PromiseLike<LooseResult> & {
  select: (columns?: string, options?: Record<string, unknown>) => LooseQuery;
  insert: (values: unknown) => LooseQuery;
  update: (values: unknown) => LooseQuery;
  eq: (column: string, value: unknown) => LooseQuery;
  gte: (column: string, value: unknown) => LooseQuery;
  in: (column: string, values: readonly unknown[]) => LooseQuery;
  neq: (column: string, value: unknown) => LooseQuery;
  order: (column: string, options?: { ascending?: boolean }) => LooseQuery;
};

export function fromUntyped(table: string): LooseQuery {
  return (supabase as unknown as { from: (name: string) => LooseQuery }).from(table);
}

type RpcError = { message: string } | null;

export async function callRpc<T = unknown>(
  fn: string,
  args?: Record<string, unknown>,
): Promise<{ data: T | null; error: RpcError }> {
  // Bind the client. Pulling `supabase.rpc` off the object drops `this`
  // and the call throws before any request is sent.
  const rpc = supabase.rpc.bind(supabase) as (
    name: string,
    params?: Record<string, unknown>,
  ) => Promise<{ data: T | null; error: RpcError }>;
  return rpc(fn, args ?? {});
}
